/**
 * customMonitor Module
 *
 * Description 运营中心
 * Author:zyy 2018-8-22
 */
'use strict';
angular.module('manageCfg.roleManageMent.permissionAssignment.operationcenter', [
    "mytAsModule",
    "mushuModule"
]);